import React, { useState } from 'react';
import { AnimatedSection } from './AnimatedSection';
import { motion } from 'framer-motion';
export function FormsSection() {
  return <section className="bg-cream py-24 px-6" data-id="element-173">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-174">
        <CommentForm data-id="element-175" />
        <ContactForm data-id="element-176" />
      </div>
    </section>;
}
function CommentForm() {
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success'>('idle');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('submitting');
    setTimeout(() => setStatus('success'), 1500);
  };
  return <AnimatedSection className="bg-white p-8 md:p-10 rounded-3xl shadow-warm" data-id="element-177">
      <h2 className="text-3xl font-bold mb-2" data-id="element-178">Deja Tu Comentario</h2>
      <p className="text-medium-brown mb-8" data-id="element-179">
        Nos encantaría conocer tu experiencia con el libro.
      </p>

      {status === 'success' ? <div className="bg-warm-beige/50 p-6 rounded-xl text-center border border-amber/20" data-id="element-180">
          <h3 className="text-xl font-semibold text-terracotta mb-2" data-id="element-181">
            ¡Gracias por compartir!
          </h3>
          <p className="text-medium-brown" data-id="element-182">
            Tu comentario ha sido recibido con mucho cariño.
          </p>
          <button onClick={() => setStatus('idle')} className="mt-4 text-sm font-medium text-terracotta hover:underline" data-id="element-183">
            Escribir otro comentario
          </button>
        </div> : <form onSubmit={handleSubmit} className="space-y-5" data-id="element-184">
          <div data-id="element-185">
            <label htmlFor="comment-name" className="block text-sm font-medium text-deep-brown mb-1" data-id="element-186">
              Nombre
            </label>
            <input type="text" id="comment-name" required className="w-full rounded-xl border border-amber/30 bg-cream/50 p-3 focus:ring-2 focus:ring-terracotta/30 focus:border-terracotta/50 outline-none transition-all" placeholder="Tu nombre" data-id="element-187" />
          </div>
          <div data-id="element-188">
            <label htmlFor="comment-email" className="block text-sm font-medium text-deep-brown mb-1" data-id="element-189">
              Correo Electrónico
            </label>
            <input type="email" id="comment-email" required className="w-full rounded-xl border border-amber/30 bg-cream/50 p-3 focus:ring-2 focus:ring-terracotta/30 focus:border-terracotta/50 outline-none transition-all" placeholder="tu@email.com" data-id="element-190" />
          </div>
          <div data-id="element-191">
            <label htmlFor="comment-text" className="block text-sm font-medium text-deep-brown mb-1" data-id="element-192">
              Comentario
            </label>
            <textarea id="comment-text" required rows={4} className="w-full rounded-xl border border-amber/30 bg-cream/50 p-3 focus:ring-2 focus:ring-terracotta/30 focus:border-terracotta/50 outline-none transition-all resize-none" placeholder="Comparte tu experiencia..." data-id="element-193"></textarea>
          </div>
          <motion.button whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} disabled={status === 'submitting'} className="w-full bg-amber text-deep-brown py-3 rounded-xl font-semibold shadow-sm hover:bg-amber-light transition-colors duration-300 disabled:opacity-70" data-id="element-194">
            {status === 'submitting' ? 'Enviando...' : 'Enviar Comentario'}
          </motion.button>
        </form>}
    </AnimatedSection>;
}
function ContactForm() {
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success'>('idle');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('submitting');
    setTimeout(() => setStatus('success'), 1500);
  };
  return <AnimatedSection delay={0.2} className="bg-deeper-beige p-8 md:p-10 rounded-3xl shadow-warm" data-id="element-195">
      <h2 className="text-3xl font-bold mb-2" data-id="element-196">Contáctanos</h2>
      <p className="text-medium-brown mb-8" data-id="element-197">
        ¿Tienes alguna pregunta? Escríbenos directamente.
      </p>

      {status === 'success' ? <div className="bg-white/50 p-6 rounded-xl text-center border border-amber/20" data-id="element-198">
          <h3 className="text-xl font-semibold text-terracotta mb-2" data-id="element-199">
            ¡Mensaje enviado!
          </h3>
          <p className="text-medium-brown" data-id="element-200">
            Te responderemos lo más pronto posible.
          </p>
          <button onClick={() => setStatus('idle')} className="mt-4 text-sm font-medium text-terracotta hover:underline" data-id="element-201">
            Enviar otro mensaje
          </button>
        </div> : <form onSubmit={handleSubmit} className="space-y-5" data-id="element-202">
          <div data-id="element-203">
            <label htmlFor="contact-name" className="block text-sm font-medium text-deep-brown mb-1" data-id="element-204">
              Nombre
            </label>
            <input type="text" id="contact-name" required className="w-full rounded-xl border border-amber/30 bg-white p-3 focus:ring-2 focus:ring-terracotta/30 focus:border-terracotta/50 outline-none transition-all" placeholder="Tu nombre" data-id="element-205" />
          </div>
          <div data-id="element-206">
            <label htmlFor="contact-email" className="block text-sm font-medium text-deep-brown mb-1" data-id="element-207">
              Correo Electrónico
            </label>
            <input type="email" id="contact-email" required className="w-full rounded-xl border border-amber/30 bg-white p-3 focus:ring-2 focus:ring-terracotta/30 focus:border-terracotta/50 outline-none transition-all" placeholder="tu@email.com" data-id="element-208" />
          </div>
          <div data-id="element-209">
            <label htmlFor="contact-subject" className="block text-sm font-medium text-deep-brown mb-1" data-id="element-210">
              Asunto
            </label>
            <input type="text" id="contact-subject" required className="w-full rounded-xl border border-amber/30 bg-white p-3 focus:ring-2 focus:ring-terracotta/30 focus:border-terracotta/50 outline-none transition-all" placeholder="¿En qué podemos ayudarte?" data-id="element-211" />
          </div>
          <div data-id="element-212">
            <label htmlFor="contact-message" className="block text-sm font-medium text-deep-brown mb-1" data-id="element-213">
              Mensaje
            </label>
            <textarea id="contact-message" required rows={3} className="w-full rounded-xl border border-amber/30 bg-white p-3 focus:ring-2 focus:ring-terracotta/30 focus:border-terracotta/50 outline-none transition-all resize-none" placeholder="Escribe tu mensaje aquí..." data-id="element-214"></textarea>
          </div>
          <motion.button whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} disabled={status === 'submitting'} className="w-full bg-terracotta text-white py-3 rounded-xl font-semibold shadow-sm hover:bg-terracotta-dark transition-colors duration-300 disabled:opacity-70" data-id="element-215">
            {status === 'submitting' ? 'Enviando...' : 'Enviar Mensaje'}
          </motion.button>
        </form>}
    </AnimatedSection>;
}